import React from "react";

const WeeklyMonitor = ({backendApiPrefix}) => {
    return (
        <div className="home">
            <h1>WeeklyMonitor</h1>
        </div>
    );
};

export default WeeklyMonitor